<template>
    <button @click="openModal" class="w-10 h-10 bg-white rounded flex justify-center items-center shadow-custom font-bold" :class="customClass" type="button">
        {{ $store?.selectedLocation?.acronym }}

    </button>
    <Modal :show-modal="showModal" @cancel="closeModal">
        <template v-slot:header>{{ $t('page.selectRegion') }}</template>
        <template v-slot:content>
            <ul>
                <li v-for="loc in locations" :key="loc.id" class="text-black hover:text-white cursor-pointer hover:bg-[#4b4b4b] p-2 rounded" :class="{'bg-[#efefef]' : loc?.id === $store.selectedLocation?.id}"><button @click="setLocation(loc)" class="w-full text-xl font-bold ">{{ loc.name }}</button></li>
            </ul>
        </template>
    </Modal>
</template>


<script>
import IconMarker from '@icons/IconMarker.vue'
import Modal from '@cmp/Modal.vue'
import { i18n } from '@/i18n'
import qs from 'qs';

export default {
    name: 'LocationButton',
    components: {
        IconMarker,
        Modal
    },
    props:{
        customClass:{
            type: String,
            required: false
        }
    },
    data() {
        return {
            loading: false,
            showModal: false
        }
    },
    methods: {
        closeModal(){
            this.showModal = false
        },
        openModal(){
            this.showModal = true
            
            
        },
        setLocation(value){
            this.$store.setLocation(value)
            this.$toast.info(`${i18n.global.t('warning.LOCATION_UPDATED')}: ${value.name}`)
            const routeMap = {
                publicationDetail: 'publications',
                foodRestaurantDetail: 'foodRestaurants',
                foodRestaurantProductDetail: 'foodRestaurants',
                storeDetail: 'stores',
                storeProductDetail: 'products',
                businessAccountsDetail: 'businessAccounts',
            };
            const currentRouteName = this.$route.name;
            const targetRouteName = routeMap[currentRouteName];

            if (targetRouteName) {
                const { href } = this.$router.resolve({ name: targetRouteName });
                if (currentRouteName === 'publicationDetail') {
                    const queryString = qs.stringify(this.$route.query);
                    window.location.href = href + (queryString ? `?${queryString}` : '');
                } else {
                    window.location.href = href;
                }
                return;
            }

            window.location.reload();
            this.closeModal()
        }
    },
    computed: {
        locations(){
            return this.$store.locations
        },
        getLocation(){
            return JSON.parse(localStorage.getItem('selectedLocation')) || 1
        }
    },
    created() {

    }
}

</script>